import { constants } from "@qgiv/core-js";

const {
    ENUMS: { PaymentType },
} = constants;

/**
 * @param {object} params
 * @param {boolean} params.hasOnePay
 * @param {object} params.values formik values
 * @returns {boolean}
 */
const getIsOnePaySubmission = ({ hasOnePay, values }) => {
    const { Payment_Type = PaymentType.NONE } = values;
    const isUsingPayPal = Payment_Type === PaymentType.PAYPAL;
    const isUsingStoredPayment = Payment_Type === PaymentType.STORED;

    const shouldUseOriginalMerchantSubmission =
        isUsingPayPal || isUsingStoredPayment;

    const isOnePaySubmission =
        hasOnePay && !shouldUseOriginalMerchantSubmission;

    return isOnePaySubmission;
};

export default getIsOnePaySubmission;
